import React from 'react'
import dayjs from 'dayjs'
import { VictoryTooltip } from 'victory'

const facilityTypeHasLessThan20Point = (scatterChartData, datum) =>
    scatterChartData.filter(x => x.FacilityType === datum.FacilityType).length <
    20

const boxEvents = [
    { mainTarget: 'q1', subTarget: 'q1Labels' },
    { mainTarget: 'q3', subTarget: 'q3Labels' },
    { mainTarget: 'median', subTarget: 'medianLabels' },
    { mainTarget: 'max', subTarget: 'maxLabels' },
    { mainTarget: 'min', subTarget: 'minLabels' },
].map(x => ({
    target: x.mainTarget, // Target the first quartile box
    eventHandlers: {
        onMouseOver: () => {
            return [
                {
                    target: x.subTarget,
                    mutation: () => ({ active: true }),
                },
                {
                    target: x.mainTarget,
                    mutation: props => {
                        return {
                            style: {
                                ...props.style,
                                stroke: 'black',
                                strokeWidth: 2,
                            },
                        }
                    },
                },
            ]
        },
        onMouseOut: () => {
            return [
                {
                    target: x.subTarget,
                    mutation: () => ({ active: false }),
                },
                {
                    mutation: props => {
                        return {
                            style: {
                                ...props.style,
                                stroke: 'grey',
                                strokeWidth: 1,
                            },
                        }
                    },
                },
            ]
        },
    },
}))

const TooltipList = ({ formattedData, isExpanded }) => (
    <div className="customTooltip boxPlotTooltip">
        <ul className="customTooltipList">
            {Object.keys(formattedData).map((k, idx) => {
                return (
                    <li key={idx}>
                        <span className="customTooltipItemName">{k}: </span>
                        <span className="customTooltipItemValue">
                            {formattedData[k]}
                        </span>
                    </li>
                )
            })}
        </ul>
    </div>
)

const ScatterTooltip = props => {
    const { x, y, dx, dy, datum, isExpanded, dimensions } = props

    const formattedData =
        datum.SampleCount > 1
            ? {
                  'Sample Count': datum.SampleCount,
                  Concentration: datum.ResultValue,
                  'Well Type': datum.FacilityTypeDisplay,
              }
            : {
                  'Clearinghouse Number': datum.ClearinghouseNumber,
                  'DNR Registration Number': datum.DNRRegistrationNumberFull,
                  'Sample Date': dayjs(datum.SampleDate).format('MM/DD/YYYY'),
                  Concentration: datum.ResultValue,
                  'Well Type': datum.FacilityTypeDisplay,
                  County: datum.CountyName,
                  NRD: datum.NRDDisplay,
              }

    const shouldFlipX = x >= dimensions.width / 2
    // const shouldFlipY = y >= dimensions.height / 2
    return (
        <g>
            <foreignObject
                x={shouldFlipX ? x - 200 - dx : x + dx}
                y={y + dy}
                width={1}
                height={1}
                style={{ overflow: 'visible' }}
            >
                <TooltipList
                    formattedData={formattedData}
                    isExpanded={isExpanded}
                />
            </foreignObject>
        </g>
    )
}

const BoxPlotTooltip = props => {
    const { datum, x, y, isExpanded, dimensions, scatterChartData } = props
    const formattedData = {
        'Upper Whisker': datum.max.toFixed(2),
        'Upper Hinge': datum.q3.toFixed(2),
        Median: datum.median.toFixed(2),
        'Lower Hinge': datum.q1.toFixed(2),
        'Lower Whisker': datum.min.toFixed(2),
    }

    const shouldFlipX = x >= dimensions.width / 2
    const yIsOutsideTopOfChart = y < 0
    const yIsOutsideBottomOfChart = y > dimensions.height
    return (
        <VictoryTooltip
            {...props}
            orientation={'left'}
            flyoutComponent={
                <foreignObject
                    x={shouldFlipX ? x - 225 : x + 10}
                    y={
                        (yIsOutsideBottomOfChart
                            ? dimensions.height
                            : yIsOutsideTopOfChart
                            ? 0
                            : y) - 85
                    }
                    width={1}
                    height={1}
                    style={{
                        overflow: 'visible',
                        visibility: facilityTypeHasLessThan20Point(
                            scatterChartData,
                            datum
                        )
                            ? 'hidden'
                            : 'visible',
                    }}
                >
                    <TooltipList
                        formattedData={formattedData}
                        isExpanded={isExpanded}
                    />
                </foreignObject>
            }
        />
    )
}

export { ScatterTooltip, boxEvents, facilityTypeHasLessThan20Point }
export default BoxPlotTooltip
